import { render, staticRenderFns } from "./ReportFields.vue?vue&type=template&id=642795aa&scoped=true"
import script from "./ReportFields.vue?vue&type=script&lang=js"
export * from "./ReportFields.vue?vue&type=script&lang=js"
import style0 from "./ReportFields.vue?vue&type=style&index=0&id=642795aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642795aa",
  null
  
)

export default component.exports